import React from 'react';
import { Card, Row, Col, Statistic, Button } from 'antd';
import { CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface NetworkStats {
  total: number;
  healthy: number;
  warning: number;
  unhealthy: number;
}

interface NetworkStatusCardProps {
  stats: NetworkStats;
  loading?: boolean;
}

const NetworkStatusCard: React.FC<NetworkStatusCardProps> = ({
  stats,
  loading = false
}) => {
  const { t } = useTranslation('networks');
  const navigate = useNavigate();

  return (
    <Card title={t('title', 'Network Status')} loading={loading}>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Statistic
            title={t('healthy', 'Healthy')}
            value={stats.healthy}
            valueStyle={{ color: '#52c41a' }}
            prefix={<CheckCircleOutlined />}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title={t('warning', 'Warning')}
            value={stats.warning}
            valueStyle={{ color: '#faad14' }}
            prefix={<WarningOutlined />}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title={t('unhealthy', 'Unhealthy')}
            value={stats.unhealthy}
            valueStyle={{ color: '#f5222d' }}
            prefix={<CloseCircleOutlined />}
          />
        </Col>
      </Row>
      <div style={{ marginTop: 16 }}>
        <Button type="link" onClick={() => navigate('/rpc')}>
          {t('viewAll', 'View Details')}
        </Button>
      </div>
    </Card>
  );
};

export default NetworkStatusCard;
